import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { setDrawerState } from '@/redux/actions/uiActions/drawerActions';
import Drawer from '@/components/Drawer';
import RowV2 from '@/components/v2/RowV2';
import ScreenBreadcrumbV2 from '@/components/v2/ScreenBreadcrumbV2';
import { FiX } from '@/components/react-icons/main';
import ScrollContainerV2 from '@/components/v2/ScrollContainerV2';
import AutosaveListRow from './autosavesDrawer/AutosaveListRow';
import Button from '../Button.jsx';
import Skeleton from '../Skeleton.jsx';

const AutosavesDrawer = ({ drawerKey = 'autosaves', title = 'Autosaves', autosaves = [], onRestore, isLoading = false }) => {
  const drawerState = useSelector((state) => state?.ui?.drawers?.[drawerKey]);
  const show = drawerState?.open;
  const stack = [{ label: title }];

  const handleClose = useCallback(() => {
    setDrawerState(drawerKey, { open: false });
  }, [drawerKey]);

  const hasAutosaves = autosaves?.length > 0;

  return (
    <Drawer className="autosaves-drawer" onHide={handleClose} show={show}>
      <RowV2 variant={'header'}>
        <RowV2.Left>
          <ScreenBreadcrumbV2 stack={stack} />
        </RowV2.Left>
        <RowV2.Right>
          <Button size={'sm'} icon={FiX} className={'ghost'} onClick={handleClose} />
        </RowV2.Right>
      </RowV2>
      <ScrollContainerV2 className="autosave-list">
        {isLoading && <Skeleton count={5} containerStyle={{ padding: '16px' }} skeletonStyle={{ height: 56, borderRadius: 8, marginBottom: 8 }} />}
        {!isLoading && !hasAutosaves && (
          <div className="autosave-empty-state">
            <span>No autosaves yet. Autosaves are created automatically when you pause editing.</span>
          </div>
        )}
        {!isLoading && hasAutosaves && autosaves.map((autosave, i) => <AutosaveListRow key={autosave?.id || i} autosave={autosave} onRestore={onRestore} handleClose={handleClose} />)}
      </ScrollContainerV2>
    </Drawer>
  );
};

export default AutosavesDrawer;
